module.exports = __webpack_public_path__ + "static/media/spinner.695888b4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/assign-prescriptions/images/spinner.gif
// module id = 31
// module chunks = 0